/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UserRouteImport } from './routes/user'
import { Route as TaskPlanningRouteImport } from './routes/task-planning'
import { Route as SweepCapacityRouteImport } from './routes/sweep-capacity'
import { Route as SensorStatusRouteImport } from './routes/sensor-status'
import { Route as OrganizationRouteImport } from './routes/organization'
import { Route as NeedForSweepRouteImport } from './routes/need-for-sweep'
import { Route as GenerateErrorRouteImport } from './routes/generate-error'
import { Route as FlueStatusRouteImport } from './routes/flue-status'
import { Route as FlueBurnsRouteImport } from './routes/flue-burns'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AbnormalBurnsRouteImport } from './routes/abnormal-burns'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SensorStatusIdRouteImport } from './routes/sensor-status.$id'
import { Route as FlueStatusIdRouteImport } from './routes/flue-status.$id'
import { Route as AuthenticationLoginCallbackRouteImport } from './routes/authentication.login-callback'

const UserRoute = UserRouteImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => rootRouteImport,
} as any)
const TaskPlanningRoute = TaskPlanningRouteImport.update({
  id: '/task-planning',
  path: '/task-planning',
  getParentRoute: () => rootRouteImport,
} as any)
const SweepCapacityRoute = SweepCapacityRouteImport.update({
  id: '/sweep-capacity',
  path: '/sweep-capacity',
  getParentRoute: () => rootRouteImport,
} as any)
const SensorStatusRoute = SensorStatusRouteImport.update({
  id: '/sensor-status',
  path: '/sensor-status',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationRoute = OrganizationRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => rootRouteImport,
} as any)
const NeedForSweepRoute = NeedForSweepRouteImport.update({
  id: '/need-for-sweep',
  path: '/need-for-sweep',
  getParentRoute: () => rootRouteImport,
} as any)
const GenerateErrorRoute = GenerateErrorRouteImport.update({
  id: '/generate-error',
  path: '/generate-error',
  getParentRoute: () => rootRouteImport,
} as any)
const FlueStatusRoute = FlueStatusRouteImport.update({
  id: '/flue-status',
  path: '/flue-status',
  getParentRoute: () => rootRouteImport,
} as any)
const FlueBurnsRoute = FlueBurnsRouteImport.update({
  id: '/flue-burns',
  path: '/flue-burns',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const AbnormalBurnsRoute = AbnormalBurnsRouteImport.update({
  id: '/abnormal-burns',
  path: '/abnormal-burns',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SensorStatusIdRoute = SensorStatusIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => SensorStatusRoute,
} as any)
const FlueStatusIdRoute = FlueStatusIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => FlueStatusRoute,
} as any)
const AuthenticationLoginCallbackRoute =
  AuthenticationLoginCallbackRouteImport.update({
    id: '/authentication/login-callback',
    path: '/authentication/login-callback',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/abnormal-burns': typeof AbnormalBurnsRoute
  '/about': typeof AboutRoute
  '/flue-burns': typeof FlueBurnsRoute
  '/flue-status': typeof FlueStatusRouteWithChildren
  '/generate-error': typeof GenerateErrorRoute
  '/need-for-sweep': typeof NeedForSweepRoute
  '/organization': typeof OrganizationRoute
  '/sensor-status': typeof SensorStatusRouteWithChildren
  '/sweep-capacity': typeof SweepCapacityRoute
  '/task-planning': typeof TaskPlanningRoute
  '/user': typeof UserRoute
  '/authentication/login-callback': typeof AuthenticationLoginCallbackRoute
  '/flue-status/$id': typeof FlueStatusIdRoute
  '/sensor-status/$id': typeof SensorStatusIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/abnormal-burns': typeof AbnormalBurnsRoute
  '/about': typeof AboutRoute
  '/flue-burns': typeof FlueBurnsRoute
  '/flue-status': typeof FlueStatusRouteWithChildren
  '/generate-error': typeof GenerateErrorRoute
  '/need-for-sweep': typeof NeedForSweepRoute
  '/organization': typeof OrganizationRoute
  '/sensor-status': typeof SensorStatusRouteWithChildren
  '/sweep-capacity': typeof SweepCapacityRoute
  '/task-planning': typeof TaskPlanningRoute
  '/user': typeof UserRoute
  '/authentication/login-callback': typeof AuthenticationLoginCallbackRoute
  '/flue-status/$id': typeof FlueStatusIdRoute
  '/sensor-status/$id': typeof SensorStatusIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/abnormal-burns': typeof AbnormalBurnsRoute
  '/about': typeof AboutRoute
  '/flue-burns': typeof FlueBurnsRoute
  '/flue-status': typeof FlueStatusRouteWithChildren
  '/generate-error': typeof GenerateErrorRoute
  '/need-for-sweep': typeof NeedForSweepRoute
  '/organization': typeof OrganizationRoute
  '/sensor-status': typeof SensorStatusRouteWithChildren
  '/sweep-capacity': typeof SweepCapacityRoute
  '/task-planning': typeof TaskPlanningRoute
  '/user': typeof UserRoute
  '/authentication/login-callback': typeof AuthenticationLoginCallbackRoute
  '/flue-status/$id': typeof FlueStatusIdRoute
  '/sensor-status/$id': typeof SensorStatusIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/abnormal-burns'
    | '/about'
    | '/flue-burns'
    | '/flue-status'
    | '/generate-error'
    | '/need-for-sweep'
    | '/organization'
    | '/sensor-status'
    | '/sweep-capacity'
    | '/task-planning'
    | '/user'
    | '/authentication/login-callback'
    | '/flue-status/$id'
    | '/sensor-status/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/abnormal-burns'
    | '/about'
    | '/flue-burns'
    | '/flue-status'
    | '/generate-error'
    | '/need-for-sweep'
    | '/organization'
    | '/sensor-status'
    | '/sweep-capacity'
    | '/task-planning'
    | '/user'
    | '/authentication/login-callback'
    | '/flue-status/$id'
    | '/sensor-status/$id'
  id:
    | '__root__'
    | '/'
    | '/abnormal-burns'
    | '/about'
    | '/flue-burns'
    | '/flue-status'
    | '/generate-error'
    | '/need-for-sweep'
    | '/organization'
    | '/sensor-status'
    | '/sweep-capacity'
    | '/task-planning'
    | '/user'
    | '/authentication/login-callback'
    | '/flue-status/$id'
    | '/sensor-status/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AbnormalBurnsRoute: typeof AbnormalBurnsRoute
  AboutRoute: typeof AboutRoute
  FlueBurnsRoute: typeof FlueBurnsRoute
  FlueStatusRoute: typeof FlueStatusRouteWithChildren
  GenerateErrorRoute: typeof GenerateErrorRoute
  NeedForSweepRoute: typeof NeedForSweepRoute
  OrganizationRoute: typeof OrganizationRoute
  SensorStatusRoute: typeof SensorStatusRouteWithChildren
  SweepCapacityRoute: typeof SweepCapacityRoute
  TaskPlanningRoute: typeof TaskPlanningRoute
  UserRoute: typeof UserRoute
  AuthenticationLoginCallbackRoute: typeof AuthenticationLoginCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/user': {
      id: '/user'
      path: '/user'
      fullPath: '/user'
      preLoaderRoute: typeof UserRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/task-planning': {
      id: '/task-planning'
      path: '/task-planning'
      fullPath: '/task-planning'
      preLoaderRoute: typeof TaskPlanningRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sweep-capacity': {
      id: '/sweep-capacity'
      path: '/sweep-capacity'
      fullPath: '/sweep-capacity'
      preLoaderRoute: typeof SweepCapacityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sensor-status': {
      id: '/sensor-status'
      path: '/sensor-status'
      fullPath: '/sensor-status'
      preLoaderRoute: typeof SensorStatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organization': {
      id: '/organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof OrganizationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/need-for-sweep': {
      id: '/need-for-sweep'
      path: '/need-for-sweep'
      fullPath: '/need-for-sweep'
      preLoaderRoute: typeof NeedForSweepRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/generate-error': {
      id: '/generate-error'
      path: '/generate-error'
      fullPath: '/generate-error'
      preLoaderRoute: typeof GenerateErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flue-status': {
      id: '/flue-status'
      path: '/flue-status'
      fullPath: '/flue-status'
      preLoaderRoute: typeof FlueStatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flue-burns': {
      id: '/flue-burns'
      path: '/flue-burns'
      fullPath: '/flue-burns'
      preLoaderRoute: typeof FlueBurnsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/abnormal-burns': {
      id: '/abnormal-burns'
      path: '/abnormal-burns'
      fullPath: '/abnormal-burns'
      preLoaderRoute: typeof AbnormalBurnsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sensor-status/$id': {
      id: '/sensor-status/$id'
      path: '/$id'
      fullPath: '/sensor-status/$id'
      preLoaderRoute: typeof SensorStatusIdRouteImport
      parentRoute: typeof SensorStatusRoute
    }
    '/flue-status/$id': {
      id: '/flue-status/$id'
      path: '/$id'
      fullPath: '/flue-status/$id'
      preLoaderRoute: typeof FlueStatusIdRouteImport
      parentRoute: typeof FlueStatusRoute
    }
    '/authentication/login-callback': {
      id: '/authentication/login-callback'
      path: '/authentication/login-callback'
      fullPath: '/authentication/login-callback'
      preLoaderRoute: typeof AuthenticationLoginCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface FlueStatusRouteChildren {
  FlueStatusIdRoute: typeof FlueStatusIdRoute
}

const FlueStatusRouteChildren: FlueStatusRouteChildren = {
  FlueStatusIdRoute: FlueStatusIdRoute,
}

const FlueStatusRouteWithChildren = FlueStatusRoute._addFileChildren(
  FlueStatusRouteChildren,
)

interface SensorStatusRouteChildren {
  SensorStatusIdRoute: typeof SensorStatusIdRoute
}

const SensorStatusRouteChildren: SensorStatusRouteChildren = {
  SensorStatusIdRoute: SensorStatusIdRoute,
}

const SensorStatusRouteWithChildren = SensorStatusRoute._addFileChildren(
  SensorStatusRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AbnormalBurnsRoute: AbnormalBurnsRoute,
  AboutRoute: AboutRoute,
  FlueBurnsRoute: FlueBurnsRoute,
  FlueStatusRoute: FlueStatusRouteWithChildren,
  GenerateErrorRoute: GenerateErrorRoute,
  NeedForSweepRoute: NeedForSweepRoute,
  OrganizationRoute: OrganizationRoute,
  SensorStatusRoute: SensorStatusRouteWithChildren,
  SweepCapacityRoute: SweepCapacityRoute,
  TaskPlanningRoute: TaskPlanningRoute,
  UserRoute: UserRoute,
  AuthenticationLoginCallbackRoute: AuthenticationLoginCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
